import moment from 'moment';
import '../../CSS/Table.css';
import { Row, Col, Tag } from 'antd';
import { connect } from 'react-redux';
import React, { Fragment, useState, useRef, useEffect } from 'react';
import { config } from '../../constant';
import Line from '../ArrayOfObjects/Line';
import ErrorComponent from '../../Utils/Error';
import NoRecordComponent from '../../Utils/NoRecords';
import { LineTabCounMock } from '../../../Mock/MockJson';
import StyledTable from "../../../../../commons/styles/table";
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const LineTableCounter = (props) => {
  const refreshDateTime = moment();
  const errorInAPI = useState(false);
  const noDataInDB = useState(false);
  const [counter,setCounter] = useState('0');
  const [currentDateData,setCurrentDateData] = useState([]);
  const [dataSource,setDataSource] = useState();
  const [graphprops,setGraphProps] = useState({
    ...props.graphprops,
    colors: [
      'orange',
      'tomato',
      'steelblue',
      'green',
      'pink',
      'voilet',
      'yellow',
      'red',
      'blue',
      'gray'
    ],
    linetype: 'line',
    startDate: moment().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
    endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    // currentDateData: [],
    disableNext: false,
    translationCache: props.translationCache || [],
    language: props.language || 'English'
  } || {});

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);
  useEffect(() => {
    return () => {
        abortController.current.abort();
      clearInterval(timeTicket);
    };
  });

  const getData = async () => {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = LineTabCounMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
            let graphpropsResult = {
          ...graphprops,
          currentDateData: json && json.query1 ? json.query1 : ''
        };
        
        setGraphProps((prevState) => ({...prevState,graphprops:graphpropsResult}));
    
        setCurrentDateData(json && json.query1 ? json.query1 : '');
        setCounter(json && json.query && json.query[0] && json.query[0].Value ? json.query[0].Value : '');
        setDataSource( json &&
          json.query2 &&
          json.query2.map((jsonData) => {
            return {
              ...jsonData,
              intervalAlias: moment.utc(jsonData.DateTime).local().format('YYYY-MM-DD HH:mm')
            };
          }));
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const refereshDataReq = () => {
    getData(props, props.selectedThemeing);
  };



  const columns = [
    {
      title: translation('Date'),
      dataIndex: 'intervalAlias',
      key: 'intervalAlias'
    },
    {
      title: translation('Value'),
      dataIndex: 'Value',
      key: 'Value'
    },
    {
      title: translation('Feedback'),
      dataIndex: 'Feedback',
      key: 'Feedback'
    }
  ];


  // const getOption = () => {
  //   let theme = props.selectedThemeing;
  //   let option = {
  //     color: ['tomato', 'steelblue', 'orange', 'yellow', 'green'],
  //     legend: {
  //       textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
  //       data: [
  //         {
  //           name: 'test1',
  //           icon: 'roundRect',
  //           textStyle: {
  //           }
  //         }
  //       ]
  //     },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: {
  //         type: 'shadow'
  //       }
  //     },
  //     toolbox: {
  //       showTitle: false,
  //       itemSize: 25,
  //       feature: {
  //         saveAsImage: {
  //           backgroundColor: 'black',
  //           title: 'download',
  //           name: props.graphprops.title,
  //           iconStyle: {
  //             borderColor: '#8c8c8c',
  //             borderWidth: 2
  //           }
  //         }
  //       }
  //     },
  //     xAxis: [
  //       {
  //         type: 'category',
  //         data: [],
  //         axisLine: {
  //           lineStyle: {
  //             color: theme === 'lightTheme' ? 'black' : 'white'
  //           }
  //         },
  //         axisTick: {
  //           show: false,
  //           lineStyle: {
  //             color: theme === 'lightTheme' ? 'black' : 'white'
  //           }
  //         },
  //         axisLabel: {
  //           color: theme === 'lightTheme' ? 'black' : 'white'
  //         }
  //       }
  //     ],
  //     yAxis: [
  //       {
  //         type: 'value',
  //         axisLine: {
  //           lineStyle: {
  //             color: theme === 'lightTheme' ? 'black' : 'white'
  //           }
  //         },
  //         axisTick: {
  //           lineStyle: {
  //             color: theme === 'lightTheme' ? 'black' : 'white'
  //           }
  //         },
  //         axisLabel: {
  //           color: theme === 'lightTheme' ? 'black' : 'white'
  //         }
  //       }
  //     ],
  //     series: []
  //   };
  //   return option;
  // };

  return (
    <Fragment>
      <div style={{ display: 'inline', color: 'white' }}>
        <label style={{ marginLeft: '9%' }}>
          {translation('Moisture Content :')}{' '}
        </label>
        <div
          style={{
            marginLeft: '6px',
            color: 'white',
            display: 'inline'
          }}
        >
          {counter}
        </div>
      </div>
      {graphprops && graphprops.checked === true ? (
        <Tag color="blue" style={{ float: '', position: 'relative', zIndex: '2' }}>
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      <span>
        <div style={{ padding: '10px' }}>
          <Row>
            <Col span={24} style={{ height: '300px' }}>
              {noDataInDB === true || errorInAPI === true ? (
                noDataInDB === true ? (
                  <NoRecordComponent />
                ) : (
                  <ErrorComponent />
                )
              ) : (
                <Line
                  graphprops={graphprops}
                  //deviceId={deviceId}
                  currentDateData={currentDateData}
                  // initialRender={initialRender}
                  refereshDataReq={refereshDataReq}
                  tableDataSource={dataSource}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div style={{ padding: '20px' }}>
                <StyledTable size="small"
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}

                  style={{ padding: '0px 10px', marginTop: '12px' }}
                  scroll={{ y: 240 }}
                  bordered
                />
              </div>
            </Col>
          </Row>
        </div>
      </span>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(LineTableCounter);
